<template>
  <nav class="nav-menu">
    <span>当前位置：</span>
    <slot></slot>
  </nav>
</template>

<script>
export default {
  name: 'NavMenu',
}
</script>

<style lang="scss" scoped>
.nav-menu {
  margin: 20px 0;
  color: #666;
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: #5689ca;
  span {
    font-size: 17px;
    color: #666;
  }
}
</style>
